/* Dog Socky - Sizing Widget | assets/sizing-widget.js */

const dsw_IMG_BASE = '';

const dsw_BREEDS = [
 // XS
 { id:'chihuahua', nl:'Chihuahua', en:'Chihuahua', search:['chihuahua','chi'], paw:[3.0,3.8], size:'XS', senior:false },
 { id:'yorkie', nl:'Yorkshire Terriër', en:'Yorkshire Terrier', search:['yorkie','yorkshire'], paw:[3.5,4.0], size:'XS', senior:false },
 { id:'pom', nl:'Dwergkeeshond', en:'Pomeranian', search:['pomeranian','dwergkees','spitz'], paw:[3.5,4.2], size:'XS', senior:false },
 { id:'toypoedel', nl:'Toy Poedel', en:'Toy Poodle', search:['toy poedel','toy poodle','mini poedel'], paw:[3.5,4.3], size:'XS', senior:false },
 { id:'maltese', nl:'Maltese', en:'Maltese', search:['maltese','maltees'], paw:[3.8,4.5], size:'XS', senior:false },
 { id:'minpin', nl:'Dwergpinscher', en:'Miniature Pinscher', search:['pinscher','minpin','dwergpinscher'], paw:[3.8,4.5], size:'XS', senior:false },
 { id:'russiantoy', nl:'Russian Toy', en:'Russian Toy', search:['russian toy','russkiy'], paw:[2.8,3.5], size:'XS', senior:false },
 // S
 { id:'jackrussell', nl:'Jack Russell Terriër', en:'Jack Russell Terrier', search:['jack russell','jackrussell'], paw:[4.0,4.8], size:'S', senior:false },
 { id:'teckel', nl:'Teckel', en:'Dachshund', search:['teckel','dachshund','dashond'], paw:[4.0,4.8], size:'S', senior:true },
 { id:'bichon', nl:'Bichon Frisé', en:'Bichon Frisé', search:['bichon','bichon frise'], paw:[4.0,4.8], size:'S', senior:false },
 { id:'shihpoo', nl:'Shih-Poo', en:'Shih-Poo', search:['shihpoo','shih poo'], paw:[4.0,4.8], size:'S', senior:false },
 { id:'papillon', nl:'Papillon', en:'Papillon', search:['papillon'], paw:[3.8,4.5], size:'S', senior:false },
 { id:'westie', nl:'West Highland Terriër', en:'Westie', search:['westie','west highland'], paw:[4.5,5.2], size:'S', senior:false },
 { id:'kingcharles', nl:'King Charles Spaniël', en:'King Charles Spaniel', search:['king charles spaniel','king charles','ruby spaniel'], paw:[3.8,4.5], size:'S', senior:false },
 { id:'cairn', nl:'Cairn Terriër', en:'Cairn Terrier', search:['cairn','cairn terrier'], paw:[4.0,5.0], size:'S', senior:false },
 // M
 { id:'shihtzu', nl:'Shih Tzu', en:'Shih Tzu', search:['shih tzu','shihtzu'], paw:[4.2,5.0], size:'M', senior:false },
 { id:'frenchbull', nl:'Franse Bulldog', en:'French Bulldog', search:['frenchie','franse bulldog','french bulldog'], paw:[4.5,5.5], size:'M', senior:true },
 { id:'cavalier', nl:'Cavalier King Charles', en:'Cavalier King Charles', search:['cavalier','ckcs'], paw:[4.8,5.5], size:'M', senior:true },
 { id:'pug', nl:'Mopshond', en:'Pug', search:['pug','mopshond','mops'], paw:[4.8,5.8], size:'M', senior:true },
 { id:'beagle', nl:'Beagle', en:'Beagle', search:['beagle'], paw:[5.0,6.1], size:'M', senior:true },
 { id:'cocker', nl:'Cocker Spaniel', en:'Cocker Spaniel', search:['cocker','cocker spaniel','engelse cocker'], paw:[5.2,6.0], size:'M', senior:true },
 { id:'sheltie', nl:'Shetland Sheepdog', en:'Sheltie', search:['sheltie','shetland','shelty'], paw:[4.8,5.8], size:'M', senior:true },
 { id:'minischnauzer',nl:'Dwergschnauzer', en:'Miniature Schnauzer', search:['schnauzer','miniatuur schnauzer'], paw:[4.5,5.2], size:'M', senior:false },
 { id:'minipoedel', nl:'Minipoedel', en:'Miniature Poodle', search:['minipoedel','mini poedel','miniature poodle'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'corgi', nl:'Welsh Corgi', en:'Corgi', search:['corgi','welsh corgi','pembroke'], paw:[5.0,6.0], size:'M', senior:false },
 { id:'whippet', nl:'Whippet', en:'Whippet', search:['whippet'], paw:[5.0,6.0], size:'M', senior:false },
 { id:'scottish', nl:'Scottish Terriër', en:'Scottish Terrier', search:['scottish','scotch terrier','scotty'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'engbull', nl:'Engelse Bulldog', en:'English Bulldog', search:['engelse bulldog','english bulldog','bulldog'], paw:[5.5,6.5], size:'M', senior:true },
 { id:'cotontulear', nl:'Coton de Tuléar', en:'Coton de Tulear', search:['coton','coton de tulear'], paw:[4.0,4.8], size:'S', senior:false },
 { id:'havanese', nl:'Havanezer', en:'Havanese', search:['havanese','havanezer'], paw:[4.0,4.8], size:'S', senior:false },
 { id:'springerspaniel',nl:'Springer Spaniel', en:'Springer Spaniel', search:['springer','springer spaniel','engelse springer'], paw:[5.5,6.5], size:'M', senior:true },
 { id:'americancocker',nl:'Amerikaanse Cocker', en:'American Cocker Spaniel', search:['amerikaanse cocker','american cocker'], paw:[5.0,5.8], size:'M', senior:true },
 { id:'bostonterrier',nl:'Boston Terriër', en:'Boston Terrier', search:['boston','boston terrier'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'lagotto', nl:'Lagotto Romagnolo', en:'Lagotto Romagnolo', search:['lagotto','lagotto romagnolo','truffelzoeker'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'welshspringer',nl:'Welsh Springer Spaniël', en:'Welsh Springer Spaniel', search:['welsh springer','welsh springer spaniel'], paw:[5.0,6.2], size:'M', senior:false },
 { id:'corgicardigan',nl:'Welsh Corgi Cardigan', en:'Welsh Corgi Cardigan', search:['corgi cardigan','cardigan corgi'], paw:[5.0,6.0], size:'M', senior:false },
 { id:'basenji', nl:'Basenji', en:'Basenji', search:['basenji'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'stdschnauzer', nl:'Middenslag Schnauzer', en:'Standard Schnauzer', search:['standard schnauzer','mittelschnauzer'], paw:[5.5,6.5], size:'M', senior:false },
 { id:'portwater', nl:'Portugese Waterhond', en:'Portuguese Water Dog', search:['portugese waterhond','portuguese water dog','portie'],paw:[5.5,6.8], size:'M', senior:false },
 { id:'boykin', nl:'Boykin Spaniël', en:'Boykin Spaniel', search:['boykin','boykin spaniel'], paw:[5.0,6.0], size:'M', senior:false },
 { id:'pon', nl:'Poolse Laaglandherder', en:'Polish Lowland Sheepdog', search:['pon','poolse laaglandherder'], paw:[5.0,6.5], size:'M', senior:false },
 // L
 { id:'border', nl:'Border Collie', en:'Border Collie', search:['border collie','border'], paw:[5.8,6.8], size:'L', senior:true },
 { id:'dalmatian', nl:'Dalmatiër', en:'Dalmatian', search:['dalmatier','dalmatiër','dalmatian'], paw:[6.0,7.0], size:'L', senior:false },
 { id:'aussie', nl:'Australian Shepherd', en:'Australian Shepherd', search:['aussie','australian shepherd','australische herder'], paw:[6.0,7.0], size:'L', senior:true },
 { id:'malinois', nl:'Mechelse Herder', en:'Belgian Malinois', search:['malinois','mechelaar','mechelse herder'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'dobermann', nl:'Dobermann', en:'Dobermann', search:['dobermann','doberman'], paw:[6.5,7.8], size:'L', senior:true },
 { id:'grootepoedel', nl:'Grote Poedel', en:'Standard Poodle', search:['grote poedel','standaard poedel','standard poodle'], paw:[6.5,7.5], size:'L', senior:true },
 { id:'siberianhusky',nl:'Siberische Husky', en:'Siberian Husky', search:['husky','siberische husky','siberian husky'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'airedale', nl:'Airedale Terriër', en:'Airedale Terrier', search:['airedale','airedale terrier'], paw:[6.0,7.0], size:'L', senior:false },
 { id:'irishsetter', nl:'Ierse Setter', en:'Irish Setter', search:['ierse setter','irish setter','red setter'], paw:[7.0,8.0], size:'XL', senior:false },
 { id:'flatcoated', nl:'Flat Coated Retriever', en:'Flat Coated Retriever', search:['flat coated','flatcoated retriever'], paw:[7.5,8.5], size:'XL', senior:true, note:'borderline XL' },
 { id:'weimaraner', nl:'Weimaraner', en:'Weimaraner', search:['weimaraner'], paw:[7.0,8.5], size:'XL', senior:false },
 { id:'boxer', nl:'Boxer', en:'Boxer', search:['boxer'], paw:[7.0,8.5], size:'XL', senior:true },
 { id:'viszla', nl:'Hongaarse Vizsla', en:'Vizsla', search:['vizsla','hongaarse vizsla'], paw:[6.5,7.5], size:'L', senior:false },
 { id:'greyhound', nl:'Windhond', en:'Greyhound', search:['windhond','greyhound','galgo'], paw:[5.5,6.5], size:'L', senior:false },
 { id:'amstaff', nl:'American Staffordshire Terriër',en:'American Staffordshire Terrier',search:['amstaff','american staffordshire','amstaf'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'toller', nl:'Nova Scotia Duck Tolling Retriever',en:'Toller', search:['toller','nova scotia','duck tolling'], paw:[5.8,7.0], size:'L', senior:false },
 { id:'hollandsherder',nl:'Hollandse Herder', en:'Dutch Shepherd', search:['hollandse herder','dutch shepherd'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'groenendael', nl:'Groenendael', en:'Belgian Shepherd Groenendael', search:['groenendael','groenendal'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'laekenois', nl:'Laekenois', en:'Belgian Shepherd Laekenois', search:['laekenois','laekenoois'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'gsp', nl:'Duitse Staande Korthaar', en:'German Shorthaired Pointer', search:['duitse staande korthaar','korthaar','gsp'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'gwp', nl:'Duitse Staande Draadhaar', en:'German Wirehaired Pointer', search:['draadhaar','german wirehaired pointer'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'englishsetter',nl:'Engelse Setter', en:'English Setter', search:['engelse setter','english setter'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'clumber', nl:'Clumber Spaniël', en:'Clumber Spaniel', search:['clumber','clumber spaniel'], paw:[6.5,7.5], size:'L', senior:true },
 { id:'sharpei', nl:'Shar Pei', en:'Shar Pei', search:['shar pei','sharpei'], paw:[6.0,7.5], size:'L', senior:true },
 { id:'bassethound', nl:'Basset Hound', en:'Basset Hound', search:['basset','basset hound'], paw:[6.0,7.5], size:'L', senior:true },
 { id:'kelpie', nl:'Australian Kelpie', en:'Australian Kelpie', search:['kelpie','australian kelpie'], paw:[5.5,7.0], size:'L', senior:false },
 { id:'acd', nl:'Australian Cattle Dog', en:'Australian Cattle Dog', search:['cattle dog','australian cattle','blue heeler'], paw:[5.5,7.0], size:'L', senior:false },
 { id:'wss', nl:'Zwitserse Witte Herder', en:'White Swiss Shepherd', search:['zwitserse witte herder','white swiss shepherd'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'gordonsetter', nl:'Gordon Setter', en:'Gordon Setter', search:['gordon setter','gordon'], paw:[7.0,8.5], size:'XL', senior:false },
 { id:'samojeed', nl:'Samojeed', en:'Samoyed', search:['samojeed','samoyed'], paw:[6.5,8.0], size:'L', senior:false },
 { id:'kees', nl:'Keeshond', en:'Keeshond', search:['keeshond','wolfsspits'], paw:[5.5,6.5], size:'L', senior:false },
 { id:'chow', nl:'Chow Chow', en:'Chow Chow', search:['chow chow','chow'], paw:[6.0,7.5], size:'L', senior:true },
 { id:'stafie', nl:'Staffordshire Bull Terriër', en:'Staffy', search:['staffordshire','staffie','staffy','stafbull'], paw:[6.0,7.5], size:'L', senior:false },
 { id:'borderterrier',nl:'Border Terriër', en:'Border Terrier', search:['border terrier'], paw:[4.5,5.5], size:'M', senior:false },
 { id:'tervueren', nl:'Tervueren', en:'Belgian Tervuren', search:['tervueren','tervuren'], paw:[6.5,8.0], size:'L', senior:true },
 // XL
 { id:'labrador', nl:'Labrador Retriever', en:'Labrador Retriever', search:['labrador','lab','labrador retriever'], paw:[7.1,8.4], size:'XL', senior:true },
 { id:'golden', nl:'Golden Retriever', en:'Golden Retriever', search:['golden','golden retriever'], paw:[7.8,9.1], size:'XL', senior:true, note:'borderline_xl_xxl' },
 { id:'gsd', nl:'Duitse Herder', en:'German Shepherd', search:['duitse herder','german shepherd','gsd','scheper'], paw:[7.5,9.0], size:'XL', senior:true, note:'borderline_xl_xxl' },
 { id:'ridgeback', nl:'Rhodesian Ridgeback', en:'Rhodesian Ridgeback', search:['ridgeback','rhodesian'], paw:[7.5,9.0], size:'XL', senior:true },
 { id:'akita', nl:'Akita', en:'Akita Inu', search:['akita','akita inu'], paw:[7.5,9.0], size:'XL', senior:true },
 { id:'hovawart', nl:'Hovawart', en:'Hovawart', search:['hovawart'], paw:[7.5,9.0], size:'XL', senior:false },
 { id:'chesapeake', nl:'Chesapeake Bay Retriever', en:'Chesapeake Bay Retriever', search:['chesapeake','chessie'], paw:[7.5,8.5], size:'XL', senior:false },
 { id:'dogo', nl:'Argentijnse Dog', en:'Dogo Argentino', search:['dogo','argentijnse dog'], paw:[9.0,11.0],size:'XXL',senior:true },
 { id:'cane', nl:'Cane Corso', en:'Cane Corso', search:['cane corso','cane'], paw:[9.0,12.0],size:'XXL',senior:true },
 { id:'curlycoated', nl:'Curly Coated Retriever', en:'Curly Coated Retriever', search:['curly coated','curly coated retriever'], paw:[7.5,9.0], size:'XL', senior:false },
 { id:'oes', nl:'Old English Sheepdog', en:'Old English Sheepdog', search:['old english sheepdog','bobtail','oes'], paw:[7.5,8.5], size:'XL', senior:true },
 { id:'briard', nl:'Briard', en:'Briard', search:['briard','berger de brie'], paw:[7.0,8.5], size:'XL', senior:true },
 { id:'giantschnauzer',nl:'Riesenschnauzer', en:'Giant Schnauzer', search:['riesenschnauzer','giant schnauzer'], paw:[7.5,9.0], size:'XL', senior:true },
 { id:'spinone', nl:'Spinone Italiano', en:'Spinone Italiano', search:['spinone','spinone italiano'], paw:[7.5,9.0], size:'XL', senior:true },
 { id:'americanbulldog',nl:'Amerikaanse Bulldog', en:'American Bulldog', search:['amerikaanse bulldog','american bulldog'], paw:[7.5,9.5], size:'XL', senior:false },
 { id:'oeb', nl:'Old English Bulldog', en:'Olde English Bulldogge', search:['old english bulldog','oud engelse bulldog'], paw:[7.0,9.0], size:'XL', senior:false },
 // XXL
 { id:'berner', nl:'Berner Sennen', en:'Bernese Mountain Dog', search:['berner','berner sennen','bernese'], paw:[8.5,10.0],size:'XXL',senior:true },
 { id:'rottweiler', nl:'Rottweiler', en:'Rottweiler', search:['rottweiler','rott','rottie'], paw:[8.6,10.2],size:'XXL',senior:true },
 { id:'newfie', nl:'Newfoundlander', en:'Newfoundland', search:['newfoundlander','newfoundland','newfie'], paw:[9.0,11.0],size:'XXL',senior:true },
 { id:'stbernard', nl:'Sint-Bernard', en:'Saint Bernard', search:['sint bernard','saint bernard','stbernard'], paw:[10.0,13.0],size:'XXL',senior:true },
 { id:'greatdane', nl:'Deense Dog', en:'Great Dane', search:['deense dog','great dane','deen'], paw:[9.0,12.0],size:'XXL',senior:true },
 { id:'leonberger', nl:'Leonberger', en:'Leonberger', search:['leonberger'], paw:[8.5,11.0],size:'XXL',senior:true },
 { id:'bouvier', nl:'Bouvier des Flandres', en:'Bouvier des Flandres', search:['bouvier','bouvier des flandres','vlaamse bouvier'], paw:[8.0,10.0],size:'XXL',senior:true },
 { id:'mastiff', nl:'Engelse Mastiff', en:'English Mastiff', search:['mastiff','engelse mastiff','english mastiff'], paw:[10.0,14.0],size:'XXL',senior:true },
 { id:'malamute', nl:'Alaskan Malamute', en:'Alaskan Malamute', search:['malamute','alaskan malamute'], paw:[8.5,10.5],size:'XXL',senior:true },
 { id:'boerboel', nl:'Boerboel', en:'Boerboel', search:['boerboel'], paw:[9.5,12.0],size:'XXL',senior:true },
 { id:'irishwolf', nl:'Ierse Wolfshond', en:'Irish Wolfhound', search:['wolfshond','ierse wolfshond','irish wolfhound'], paw:[10.0,13.0],size:'XXL',senior:true },
 { id:'bullmastiff', nl:'Bulmastieff', en:'Bullmastiff', search:['bulmastieff','bullmastiff'], paw:[9.0,10.5],size:'XXL',senior:true },
 { id:'bloodhound', nl:'Bloedhond', en:'Bloodhound', search:['bloedhond','bloodhound'], paw:[8.5,10.0],size:'XXL',senior:true },
 { id:'anatolian', nl:'Anatolische Herder', en:'Anatolian Shepherd', search:['anatolische herder','anatolian shepherd'], paw:[9.0,11.0],size:'XXL',senior:true },
 { id:'kangal', nl:'Kangal', en:'Kangal', search:['kangal'], paw:[9.0,12.0],size:'XXL',senior:false },
 { id:'kuvasz', nl:'Kuvasz', en:'Kuvasz', search:['kuvasz'], paw:[8.5,10.5],size:'XXL',senior:true },
 { id:'greatpyrenees',nl:'Pyreneese Berghond', en:'Great Pyrenees', search:['pyreneese berghond','great pyrenees','patou'], paw:[9.0,11.0],size:'XXL',senior:true },
 { id:'deerhound', nl:'Scottish Deerhound', en:'Scottish Deerhound', search:['scottish deerhound','deerhound'], paw:[8.0,10.0],size:'XXL',senior:true },
 { id:'landseer', nl:'Landseer', en:'Landseer', search:['landseer'], paw:[9.0,12.0],size:'XXL',senior:true },
 // Nieuwe rassen (toegevoegd voor 90% BE/NL dekking)
 { id:'bordeaux',    nl:'Bordeauxdog',    en:'Dogue de Bordeaux', search:['bordeauxdog','dogue de bordeaux','bordeaux dog'],          paw:[8.5,11.0], size:'XXL', senior:true },
 { id:'shibainu',    nl:'Shiba Inu',       en:'Shiba Inu',          search:['shiba','shiba inu'],                                     paw:[3.8,5.0],  size:'S',   senior:false },
 { id:'stabyhoun',   nl:'Stabyhoun',       en:'Stabyhoun',          search:['stabyhoun','stabij'],                                    paw:[5.0,6.5],  size:'M',   senior:false },
 { id:'kooiker',     nl:'Kooikerhondje',   en:'Kooikerhondje',      search:['kooiker','kooikerhondje'],                               paw:[3.8,5.0],  size:'S',   senior:false },
 { id:'bullterrier', nl:'Bull Terriër',    en:'Bull Terrier',       search:['bull terrier','bullterrier','bulteriër'],                paw:[5.8,7.0],  size:'L',   senior:false },
];

const dsw_WEIGHTS = {
 chihuahua:[1.5,3.0], yorkie:[2.0,3.2], pom:[1.9,3.5], toypoedel:[2.0,4.0], maltese:[2.0,4.0],
 minpin:[4.0,6.0], russiantoy:[1.0,3.0], jackrussell:[6.0,8.0], teckel:[7.0,15.0], bichon:[4.0,9.0],
 shihpoo:[4.0,9.0], papillon:[3.0,5.0], westie:[7.0,10.0], kingcharles:[3.6,6.4], cairn:[5.5,8.0],
 shihtzu:[4.0,8.0], frenchbull:[8.0,14.0], cavalier:[6.0,8.5], pug:[6.0,9.0], beagle:[9.0,14.0],
 cocker:[12.0,16.0], sheltie:[6.0,12.0], minischnauzer:[5.5,9.0], minipoedel:[4.0,9.0], corgi:[10.0,14.0],
 whippet:[9.0,18.0], scottish:[8.0,10.5], engbull:[18.0,25.0], cotontulear:[3.5,6.0], havanese:[3.0,6.0],
 springerspaniel:[18.0,25.0], americancocker:[11.0,14.0], bostonterrier:[4.5,11.3], lagotto:[13.0,16.0], welshspringer:[16.0,20.0],
 corgicardigan:[11.0,17.0], basenji:[9.5,11.0], stdschnauzer:[14.0,20.0], portwater:[16.0,25.0], boykin:[11.0,18.0],
 pon:[14.0,23.0], border:[14.0,20.0], dalmatian:[23.0,32.0], aussie:[16.0,32.0], malinois:[20.0,30.0],
 dobermann:[32.0,45.0], grootepoedel:[20.0,32.0], siberianhusky:[16.0,27.0], airedale:[18.0,29.0], irishsetter:[27.0,32.0],
 flatcoated:[25.0,36.0], weimaraner:[25.0,40.0], boxer:[25.0,32.0], viszla:[20.0,29.0], greyhound:[27.0,40.0],
 amstaff:[18.0,32.0], toller:[14.0,23.0], hollandsherder:[20.0,35.0], groenendael:[20.0,30.0], laekenois:[20.0,30.0],
 gsp:[20.0,32.0], gwp:[25.0,34.0], englishsetter:[20.0,36.0], clumber:[25.0,39.0], sharpei:[18.0,30.0],
 bassethound:[20.0,34.0], kelpie:[14.0,20.0], acd:[14.0,22.0], wss:[25.0,40.0], gordonsetter:[20.0,36.0],
 samojeed:[16.0,30.0], kees:[16.0,20.0], chow:[20.0,32.0], stafie:[11.0,17.0], borderterrier:[5.0,7.1],
 tervueren:[20.0,30.0], labrador:[25.0,36.0], golden:[25.0,34.0], gsd:[22.0,40.0], ridgeback:[29.0,41.0],
 akita:[32.0,59.0], hovawart:[25.0,45.0], chesapeake:[25.0,36.0], dogo:[35.0,45.0], cane:[40.0,50.0],
 curlycoated:[29.0,41.0], oes:[27.0,45.0], briard:[30.0,40.0], giantschnauzer:[27.0,48.0], spinone:[29.0,39.0],
 americanbulldog:[27.0,54.0], oeb:[27.0,45.0], berner:[36.0,52.0], rottweiler:[36.0,60.0], newfie:[54.0,68.0],
 stbernard:[54.0,82.0], greatdane:[45.0,90.0], leonberger:[41.0,75.0], bouvier:[35.0,54.0], mastiff:[54.0,113.0],
 malamute:[32.0,50.0], boerboel:[65.0,90.0], irishwolf:[40.0,82.0], bullmastiff:[45.0,60.0], bloodhound:[36.0,54.0],
 anatolian:[41.0,68.0], kangal:[41.0,66.0], kuvasz:[30.0,52.0], greatpyrenees:[36.0,54.0], deerhound:[36.0,50.0],
 landseer:[59.0,80.0], bordeaux:[45.0,68.0], shibainu:[8.0,14.0], stabyhoun:[18.0,25.0], kooiker:[9.0,14.0],
 bullterrier:[20.0,38.0]
};

const dsw_SIZES = {
 XS: { min: 0, max: 4.3, label:'XS', range:'< 4,3 cm' },
 S: { min: 4.3, max: 4.9, label:'S', range:'4,3 – 4,9 cm' },
 M: { min: 4.9, max: 6.3, label:'M', range:'4,9 – 6,3 cm' },
 L: { min: 6.3, max: 7.3, label:'L', range:'6,3 – 7,3 cm' },
 XL: { min: 7.3, max: 8.6, label:'XL', range:'7,3 – 8,6 cm' },
 XXL: { min: 8.6, max: 99, label:'XXL', range:'> 8,6 cm' },
};

function dsw_sizeFromCm(cm) {
 for (const [key, s] of Object.entries(dsw_SIZES)) {
 if (cm < s.max) return key;
 }
 return 'XXL';
}

let dswState = {
 path: null, breed: null, variant: null, fur: null,
 cm: 5.0, history: [], currentScreen: 'dsw-s0',
};

const DSW_SCREEN_STEPS = {
 'dsw-s0': { step: 0, total: 4 },
 'dsw-s1a': { step: 1, total: 4 },
 'dsw-s1b': { step: 2, total: 4 },
 'dsw-s1c': { step: 1, total: 3 },
 'dsw-s2': { step: 3, total: 4 },
 'dsw-s3': { step: 4, total: 4 },
 'dsw-sxs': { step: 4, total: 4 },
 'dsw-sxxl': { step: 4, total: 4 },
};

function dsw_showScreen(id, push = true) {
 if (push && dswState.currentScreen !== id) dswState.history.push(dswState.currentScreen);
 document.querySelectorAll('.dsw-wrap .screen').forEach(s => s.classList.remove('active'));
 const el = document.getElementById(id);
 if (el) el.classList.add('active');
 dswState.currentScreen = id;
 dsw_updateProgress(id);
 const modal = document.getElementById('dsw-modal');
 if (modal && modal.classList.contains('open')) {
 modal.querySelector('.dsw-modal-body').scrollTop = 0;
 } else {
 const bp = el && el.closest('.ds-bp__modal-content'); if (bp) bp.scrollTop = 0;
 }
}

function dsw_goBack() {
 if (!dswState.history.length) return;
 dsw_showScreen(dswState.history.pop(), false);
}

function dsw_reset() {
 dswState = { path:null, breed:null, variant:null, fur:null, cm:5.0, history:[], currentScreen:'dsw-s0' };
 const bs = document.getElementById('dsw-breed-search');
 if (bs) bs.value = '';
 dsw_renderBreedList('');
 dsw_updateCmDisplay();
 dsw_updatePreviewBar();
 dsw_showScreen('dsw-s0', false);
}

function dsw_updateProgress(id) {
 const s = DSW_SCREEN_STEPS[id] || { step: 0, total: 4 };
 document.querySelectorAll('.dsw-wrap .dot').forEach((d, i) => {
 d.className = 'dot';
 if (i < s.step - 1) d.classList.add('done');
 else if (i === s.step - 1) d.classList.add('active');
 });
 const lbl = document.getElementById('dsw-progress-label');
 if (!lbl) return;
 if (id === 'dsw-s0') lbl.textContent = '';
 else if (id === 'dsw-s3' || id === 'dsw-sxxl') lbl.textContent = 'Resultaat';
 else lbl.textContent = `Stap ${s.step} van ${s.total}`;
}

function dsw_choosePath(path) {
 dswState.path = path;
 if (path === 'breed') {
 dsw_showScreen('dsw-s1a');
 setTimeout(() => { const el = document.getElementById('dsw-breed-search'); if (el) el.focus(); }, 300);
 dsw_renderBreedList('');
 } else {
 dsw_showScreen('dsw-s1c');
 dsw_updateCmDisplay();
 dsw_updatePreviewBar();
 }
}

const DSW_BADGE = { XS:'badge-xs', S:'badge-s', M:'badge-m', L:'badge-l', XL:'badge-xl', XXL:'badge-xxl' };

function dsw_renderBreedList(q) {
 const list = document.getElementById('dsw-breed-list');
 if (!list) return;
 const query = q.trim().toLowerCase();
 let breeds = query
 ? dsw_BREEDS.filter(b => b.nl.toLowerCase().includes(query) || b.en.toLowerCase().includes(query) || b.search.some(s => s.includes(query)))
 : dsw_BREEDS.slice().sort((a, b) => a.nl.localeCompare(b.nl, 'nl'));
 if (!breeds.length) {
 list.innerHTML = '<div class="no-results">Geen ras gevonden. Probeer de <strong>meetmethode</strong> of typ een Engelse rasnaam.</div>';
 return;
 }
 list.innerHTML = breeds.map(b => {
 const badge = DSW_BADGE[b.size] || 'badge-m';
 const paw = `${b.paw[0].toFixed(1)}–${b.paw[1].toFixed(1)} cm`;
 const senior = b.senior ? ' 🐾' : '';
 const photo = dsw_IMG_BASE
 ? `<img class="breed-img" src="${dsw_IMG_BASE}breed_${b.id}.webp" alt="${b.nl}" loading="lazy" onerror="this.outerHTML='<div class=breed-img-ph>🐾</div>'">`
 : '<div class="breed-img-ph">🐾</div>';
 return `<div class="breed-item" onclick="dsw_selectBreed('${b.id}')">${photo}<div class="breed-info"><div class="breed-name">${b.nl}${senior}</div><div class="breed-sub">${b.en.replace(/Miniature/g,'Dwerg')} · ${paw}</div></div><span class="breed-badge ${badge}">${b.size}</span></div>`;
 }).join('');
}

function dsw_filterBreeds(q) { dsw_renderBreedList(q); }

function dsw_selectBreed(id) {
 dswState.breed = dsw_BREEDS.find(b => b.id === id);
 const nameEl = document.getElementById('dsw-variant-breed-name');
 const bcEl = document.getElementById('dsw-bc-breed');
 if (nameEl) nameEl.textContent = dswState.breed.nl;
 if (bcEl) bcEl.textContent = dswState.breed.nl;
 dsw_updateVariantOptions(dswState.breed);
 document.querySelectorAll('#dsw-s1b .option-btn').forEach(b => b.classList.remove('selected'));
 dswState.variant = null;
 dsw_showScreen('dsw-s1b');
}

function dsw_updateVariantOptions(breed) {
 const w = dsw_WEIGHTS[breed.id];
 if (!w) return;
 const M = 0.15;
 const fmt = kg => kg < 2 ? kg.toFixed(1) : Math.round(kg);
 const kleinMax = Math.round(w[0] * (1 - M));
 const grootMin = Math.round(w[1] * (1 + M));
 const sd = document.getElementById('dsw-variant-small-desc');
 const ad = document.getElementById('dsw-variant-avg-desc');
 const ld = document.getElementById('dsw-variant-large-desc');
 if (sd) sd.textContent = `Weegt minder dan ${fmt(kleinMax)} kg, duidelijk lichter dan typisch voor de ${breed.nl}`;
 if (ad) ad.textContent = `Weegt ${fmt(kleinMax)}–${fmt(grootMin)} kg, typisch gewicht voor de ${breed.nl}`;
 if (ld) ld.textContent = `Weegt meer dan ${fmt(grootMin)} kg, zwaargebouwd en boven het rasgemiddelde`;
}

function dsw_selectVariant(v, btn) {
 dswState.variant = v;
 document.querySelectorAll('#dsw-s1b .option-btn').forEach(b => b.classList.remove('selected'));
 btn.classList.add('selected');
 setTimeout(dsw_showFurScreen, 300);
}

function dsw_showFurScreen() {
 const bc = document.getElementById('dsw-bc-fur');
 if (bc) {
 if (dswState.path === 'breed') {
 const vl = { small:'kleiner', avg:'gemiddeld', large:'groter' }[dswState.variant] || '';
 bc.innerHTML = `<span class="crumb">${dswState.breed.nl}</span><span class="sep"> › </span><span>${vl}</span>`;
 } else {
 bc.innerHTML = `<span class="crumb">${dswState.cm.toFixed(1).replace('.',',')} cm</span>`;
 }
 }
 document.querySelectorAll('#dsw-s2 .option-btn').forEach(b => b.classList.remove('selected'));
 dswState.fur = null;
 dsw_showScreen('dsw-s2');
}

function dsw_selectFur(f, btn) {
 dswState.fur = f;
 document.querySelectorAll('#dsw-s2 .option-btn').forEach(b => b.classList.remove('selected'));
 btn.classList.add('selected');
 setTimeout(dsw_showResult, 350);
}

function dsw_changeCm(delta) {
 dswState.cm = Math.round(Math.max(1.0, Math.min(15.0, dswState.cm + delta)) * 10) / 10;
 dsw_updateCmDisplay();
 dsw_updatePreviewBar();
}

function dsw_sliderChange(val) {
 dswState.cm = Math.round(parseFloat(val) * 10) / 10;
 dsw_updateCmDisplay();
 dsw_updatePreviewBar();
}

function dsw_updateCmDisplay() {
 const el = document.getElementById('dsw-cm-display');
 if (el) el.textContent = dswState.cm.toFixed(1).replace('.', ',');
 const slider = document.getElementById('dsw-cm-slider');
 if (slider) {
 const min = parseFloat(slider.min), max = parseFloat(slider.max);
 const clamped = Math.max(min, Math.min(max, dswState.cm));
 slider.value = clamped;
 const pct = ((clamped - min) / (max - min)) * 100;
 slider.style.background = `linear-gradient(to right, var(--brand) 0%, var(--brand) ${pct}%, #E5D5CC ${pct}%, #E5D5CC 100%)`;
 }
}

function dsw_updatePreviewBar() {
 const thresholds = [4.3, 4.9, 6.3, 7.3, 8.6];
 const segs = ['xs','s','m','l','xl'];
 let active = 4;
 for (let i = 0; i < thresholds.length; i++) {
 if (dswState.cm < thresholds[i]) { active = i; break; }
 }
 segs.forEach((s, i) => {
 const el = document.getElementById('dsw-seg-' + s);
 if (el) el.className = 'seg' + (i === active ? ' active' : '');
 });
}

function dsw_goToFur() { dsw_showFurScreen(); }

function dsw_showResult() {
 const furMod = { low: 0, mid: 0, high: 0.7 }[dswState.fur] ?? 0;
 const variantMod = { small: 0.92, avg: 1.0, large: 1.08 }[dswState.variant] ?? 1.0;

 if (dswState.path === 'breed') {
 const b = dswState.breed;
 const mean = (b.paw[0] + b.paw[1]) / 2;
 const afterVariant = mean * variantMod;
 const finalCm = afterVariant + furMod;
 const size = dsw_sizeFromCm(finalCm);
 dsw_setEl('dsw-calc-label-1', `Gem. pootbreedte (${b.nl})`);
 dsw_setEl('dsw-calc-val-1', `${mean.toFixed(1).replace('.',',')} cm`);
 dsw_setEl('dsw-calc-label-2', { small:'Lichte variant (×0,92)', avg:'', large:'Zware variant (×1,08)' }[dswState.variant] || '');
 dsw_setEl('dsw-calc-val-2', `${afterVariant.toFixed(1).replace('.',',')} cm`);
 dsw_setEl('dsw-calc-val-3', `${finalCm.toFixed(1).replace('.',',')} cm`);
 dsw_setEl('dsw-calc-total', `~${finalCm.toFixed(1).replace('.',',')} cm`);
 dsw_showRow('dsw-calc-row-2', dswState.variant !== 'avg');
 dsw_showRow('dsw-calc-row-3', dswState.fur === 'high');
 dsw_renderResult(size, finalCm, b);
 } else {
 const finalCm = dswState.cm + furMod;
 const size = dsw_sizeFromCm(finalCm);
 dsw_setEl('dsw-calc-label-1', 'Gemeten pootbreedte');
 dsw_setEl('dsw-calc-val-1', `${dswState.cm.toFixed(1).replace('.',',')} cm`);
 dsw_setEl('dsw-calc-val-3', `${finalCm.toFixed(1).replace('.',',')} cm`);
 dsw_setEl('dsw-calc-total', `${finalCm.toFixed(1).replace('.',',')} cm`);
 dsw_showRow('dsw-calc-row-2', false);
 dsw_showRow('dsw-calc-row-3', dswState.fur === 'high');
 dsw_renderResult(size, finalCm, null);
 }
}

function dsw_setEl(id, text) {
 const el = document.getElementById(id);
 if (el) el.textContent = text;
}

function dsw_showRow(id, show) {
 const el = document.getElementById(id);
 if (el) el.style.display = show ? 'flex' : 'none';
}

function dsw_renderResult(size, finalCm, breed) {
 if (size === 'XXL') { dsw_showScreen('dsw-sxxl'); return; }
 if (size === 'XS') { dsw_showScreen('dsw-sxs'); return; }
 const s = dsw_SIZES[size];
 dsw_setEl('dsw-result-size', size);
 dsw_setEl('dsw-result-range', `Pootbreedte ${s.range}`);
 const tagEl = document.getElementById('dsw-result-tag');
 if (tagEl) tagEl.textContent = breed ? `🐾 ${breed.nl} · ~${finalCm.toFixed(1).replace('.',',')} cm` : `📏 Gemeten: ${dswState.cm.toFixed(1).replace('.',',')} cm`;

 const seniorCard = document.getElementById('dsw-senior-card');
 if (seniorCard) seniorCard.style.display = (breed && breed.senior) ? 'block' : 'none';

 const borderCard = document.getElementById('dsw-borderline-card');
 const borderText = document.getElementById('dsw-borderline-text');
 let showBorder = false;
 if (borderCard && borderText) {
 if (breed && breed.note === 'borderline_xl_xxl') {
 showBorder = true;
 borderText.innerHTML = `De ${breed.nl} zit op de grens van XL en XXL. Grote of zwaargebouwde exemplaren kunnen XL te klein vinden. Twijfel? Meet de pootbreedte voor zekerheid.`;
 } else if (finalCm > s.max - 0.3) {
 showBorder = true;
 const next = dsw_nextSize(size);
 borderText.innerHTML = next === 'XXL'
 ? 'Je hond zit aan de bovengrens van XL. Als de sok te strak voelt: XXL is in ontwikkeling, schrijf je in op de wachtlijst.'
 : `Je hond zit aan de bovengrens van maat ${size}. Bij twijfel raden we maat ${next} aan. Gebruik onze <strong>30-dagen gratis maatruil</strong>.`;
 } else if (finalCm < s.min + 0.2 && s.min > 0) {
 showBorder = true;
 borderText.innerHTML = `Je hond zit aan de ondergrens van maat ${size}. Als de sok te los aanvoelt, kies dan één maat kleiner. Gebruik onze <strong>30-dagen gratis maatruil</strong>.`;
 }
 borderCard.style.display = showBorder ? 'block' : 'none';
 }

 dsw_setEl('dsw-cta-btn-size', size);
 const ctaBtn = document.getElementById('dsw-cta-btn');
 if (ctaBtn) {
 const onProductPage = document.querySelector('[data-dsw-product-page]');
 if (onProductPage) {
 ctaBtn.href = '#';
 ctaBtn.onclick = function(e) {
 e.preventDefault();
 dsw_closeModal();
 dsw_selectShopifyVariant(size);
 };
 }
 }
 dsw_showScreen('dsw-s3');
}

function dsw_nextSize(s) {
 const order = ['XS','S','M','L','XL','XXL'];
 const i = order.indexOf(s);
 return i < order.length - 1 ? order[i + 1] : 'XXL';
}

function dsw_selectShopifyVariant(size) {
 const btn = document.querySelector(`.product-form__input input[value="${size}"], .variant__button-label`);
 if (!btn) return;
 const input = document.querySelector(`input[value="${size}"]`);
 if (input) { input.click(); }
 const anchor = document.querySelector('.product-form__input');
 if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

function dsw_openModal() {
 const modal = document.getElementById('dsw-modal');
 if (modal) { modal.classList.add('open'); document.body.style.overflow = 'hidden'; }
}

function dsw_closeModal() {
 const modal = document.getElementById('dsw-modal');
 if (modal) { modal.classList.remove('open'); document.body.style.overflow = ''; }
}

function dsw_submitXsWaitlist() {
 const email = document.getElementById('dsw-xs-email');
 if (!email || !email.value.includes('@')) { if (email) email.style.borderColor = '#fa4f0d'; return; }
 const form = document.querySelector('#dsw-sxs .email-form');
 const sent = document.getElementById('dsw-xs-email-sent');
 if (form) form.style.display = 'none';
 if (sent) sent.style.display = 'block';
}

function dsw_submitWaitlist() {
 const email = document.getElementById('dsw-waitlist-email');
 if (!email || !email.value.includes('@')) { if (email) email.style.borderColor = '#fa4f0d'; return; }
 const form = document.querySelector('#dsw-sxxl .email-form');
 const sent = document.getElementById('dsw-email-sent');
 if (form) form.style.display = 'none';
 if (sent) sent.style.display = 'block';
}

(function dsw_init() {
 function run() {
 if (!document.getElementById('dsw-s0')) return;
 dsw_renderBreedList('');
 dsw_updateCmDisplay();
 dsw_updatePreviewBar();
 dsw_updateProgress('dsw-s0');
 const search = document.getElementById('dsw-breed-search');
 if (search) {
 search.addEventListener('keydown', function(e) {
 if (e.key === 'Enter') {
 const first = document.querySelector('#dsw-breed-list .breed-item');
 if (first) first.click();
 }
 });
 }
 const modal = document.getElementById('dsw-modal');
 if (modal) {
 modal.addEventListener('click', function(e) {
 if (e.target === modal) dsw_closeModal();
 });
 document.addEventListener('keydown', function(e) {
 if (e.key === 'Escape') dsw_closeModal();
 });
 }
 }
 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', run);
 } else {
 run();
 }
})();



/* === Klaviyo wachtlijst-koppeling (Dog Socky) ===
   Schrijft XS/XXL-wachtlijst e-mails naar Klaviyo:
   - XS  -> lijst Rr9RzG (Waitlist XS)  + TvBNSn (Email List, triggert Welkomstserie 15%)
   - XXL -> lijst V8DT6z (Waitlist XXL) + TvBNSn
   Deze functies overschrijven bewust de gelijknamige basisfuncties hierboven. */
function dsw_klaviyoSubscribe(email, maat, listIds) {
 listIds.forEach(function (listId) {
  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=RCMV3W', {
   method: 'POST',
   headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
   body: JSON.stringify({
    data: {
     type: 'subscription',
     attributes: {
      profile: { data: { type: 'profile', attributes: { email: email, properties: { waitlist_maat: maat } } } },
      custom_source: 'Maatcalculator wachtlijst ' + maat
     },
     relationships: { list: { data: { type: 'list', id: listId } } }
    }
   })
  }).catch(function () {});
 });
}
function dsw_submitXsWaitlist() {
 const email = document.getElementById('dsw-xs-email');
 if (!email || !email.value.includes('@')) { if (email) email.style.borderColor = '#fa4f0d'; return; }
 dsw_klaviyoSubscribe(email.value.trim(), 'XS', ['Rr9RzG', 'TvBNSn']);
 const form = document.querySelector('#dsw-sxs .email-form');
 const sent = document.getElementById('dsw-xs-email-sent');
 if (form) form.style.display = 'none';
 if (sent) sent.style.display = 'block';
}
function dsw_submitWaitlist() {
 const email = document.getElementById('dsw-waitlist-email');
 if (!email || !email.value.includes('@')) { if (email) email.style.borderColor = '#fa4f0d'; return; }
 dsw_klaviyoSubscribe(email.value.trim(), 'XXL', ['V8DT6z', 'TvBNSn']);
 const form = document.querySelector('#dsw-sxxl .email-form');
 const sent = document.getElementById('dsw-email-sent');
 if (form) form.style.display = 'none';
 if (sent) sent.style.display = 'block';
}